<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <path d="M17.27,17.73l-.94,10.51h5.96l-8.86,13.56.94-10.51h-5.96l8.86-13.56M17.27,14.73c-.99,0-1.95.49-2.51,1.36l-8.86,13.56c-.6.92-.65,2.1-.13,3.07.52.97,1.54,1.57,2.64,1.57h2.68l-.65,7.24c-.12,1.37.7,2.65,2,3.1.32.11.66.17.98.17.99,0,1.95-.49,2.51-1.36l8.86-13.56c.6-.92.65-2.1.13-3.07-.52-.97-1.54-1.57-2.64-1.57h-2.68l.65-7.24c.12-1.37-.7-2.65-2-3.1-.32-.11-.66-.17-.98-.17h0Z" fill="currentcolor"/>
    <g>
      <polygon points="44.95 39.63 41.95 39.63 41.95 3.07 8.97 3.07 8.88 3.16 8.88 19.6 5.88 19.6 5.88 1.96 7.69 .07 44.95 .07 44.95 39.63" fill="currentcolor"/>
      <g>
        <polygon points="34.99 34.85 31.99 34.85 31.99 29.64 38.31 29.64 38.31 32.64 34.99 32.64 34.99 34.85" fill="currentcolor"/>
        <polygon points="34.99 24.81 31.99 24.81 31.99 19.6 38.31 19.6 38.31 22.6 34.99 22.6 34.99 24.81" fill="currentcolor"/>
        <polygon points="25.29 14.77 22.29 14.77 22.29 9.56 28.61 9.56 28.61 12.56 25.29 12.56 25.29 14.77" fill="currentcolor"/>
        <polygon points="34.99 14.77 31.99 14.77 31.99 9.56 38.31 9.56 38.31 12.56 34.99 12.56 34.99 14.77" fill="currentcolor"/>
      </g>
    </g>
  </svg>
</template>

<style scoped lang="scss">

</style>